module.exports = {
      id: "icon-audio-previous-usage",
      viewBox: "0 0 35.504 35.504",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-audio-previous",
      toString: function () {
        return this.url;
      }
    }